export const REF_INITIAL_VERSION = 'initial_version';

export function schemaValidationWorkflowIdForVersion(
  versionId: string
): string {
  return `updateSchemaForReferenceDataRevisionsWorkflow-${versionId}`;
}

// Column names for date range columns in reference tables
export const START_DATE_COLUMN_NAME = 'start_date';
export const END_DATE_COLUMN_NAME = 'end_date';
export const DATE_RANGE_COLUMN_NAMES = [
  START_DATE_COLUMN_NAME,
  END_DATE_COLUMN_NAME,
];
